import { useEffect, useContext, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Utils from "../../Utils";
import axios from "axios";
import PrRequestUpload from "../../components/photographer/PrRequestUpload";
import { RecceTab } from "../../components/common";
import Shotlists from "../../components/discussion/Shotlists";
import _ from "lodash";
import FinalDocumentTab from "../../components/photographer/FinalDocumentTab";
import Swal from "sweetalert2";

const PhPhotoshootDetails = (props) => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const fileInputRefPh = useRef(null);
  const [prReadyIds, setPrReadyIds] = useState([]);
  const [filter, setFilter] = useState({ pr_status: 0 }); // 0 = No Pr, 1 = PR Requested, 2 = PR Ready
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setStatus(res.data.statuses);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  /* Classes for specific status */
  const statusClasses = {
    Pending: "status-pill inline-block bg-pink-100 text-pink-700",
    Completed: "status-pill inline-block bg-green-200 text-green-700",
  };

  /* Hotel types */
  const hotel_types = {
    new: "New Property",
    converted: "Converted Property",
    established: "Established Property",
  };

  /* Handle PR Ready Change */
  const handlePrReadyChange = (photoId) => {
    setPrReadyIds((prev) => {
      if (prev.includes(photoId)) {
        // remove if unchecked
        return prev.filter((id) => id !== photoId);
      } else {
        // add if checked
        return [...prev, photoId];
      }
    });
  };

  /* Recce Images Listing */
  const [recceImages, setRecceImages] = useState([]);
  const updateRecceImages = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/recces/${id}?limit=9999`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setRecceImages(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  const [photoshootDetails, setPhotoshootDetails] = useState([]);
  const [activeTab, setActiveTab] = useState("shotlist");
  const [activePsTab, setActivePsTab] = useState("uploaded");

  const fetchPhotoshootDetails = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/${id}`), Utils.apiHeaders())
      .then((res) => {
        if (res.status == 200) {
          console.log("Photoshoot Details", res.data);
          setPhotoshootDetails(res.data);
          //updateRecceImages();
          updatePhotoshootImages();
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  //const [hotelDetails, setHotelDetails] = useState([]);
  useEffect(() => {
    /* Getting Photoshoot Details */
    fetchPhotoshootDetails();
  }, []);

  const canShotList = () => [1, 2, 3, 4, 5, 6].includes(photoshootDetails.status);

  const canSDeck = () => [1, 2, 3, 4, 5, 6].includes(photoshootDetails.status);

  const canPSRecceUpload = () => [1, 2, 3, 4, 5, 6].includes(photoshootDetails.status);

  const canUploadPhotos = () => [7, 8].includes(photoshootDetails.status);

  const psApproved = () => photoshootDetails.status >= 9;

  useEffect(() => {
    if (canShotList()) {
      setActiveTab("shotlist");
    } else if (canSDeck()) {
      setActiveTab("sdeck");
    } else if (canPSRecceUpload()) {
      setActiveTab("recce");
    } else if (canUploadPhotos()) {
      setActiveTab("photoshoot");
    } else if (psApproved()) {
      setActivePsTab("approved");
      setActiveTab("finaldocs");
    }
  }, [photoshootDetails]);

  /* Photoshoot Images Listing */
  const [photoshootImages, setPhotoshootImages] = useState([]);
  const [photoshootFiles, setPhotoshootFiles] = useState([]);
  const updatePhotoshootImages = () => {
    axios
      .get(Utils.apiUrl(`photoshoot/photos?psid=${id}`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setPhotoshootImages(res.data.data);
          setPhotoshootFiles(_.groupBy(res.data.files, "photo_ids"));
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  /* For deleting uploaded photoshoot file */

  const deletePhotoshootFile = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This file will be deleted permanently",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(Utils.apiUrl(`photoshoot/photo/${id}`), Utils.apiHeaders())
          .then((res) => {
            if (res.data.success) {
              updatePhotoshootImages();

              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: res.data.message,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Failed",
                text: res.data.message,
              });
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to delete file",
            });
          });
      }
    });
  };
  // Drag and drop handlers for Photoshoot Images
  const handleDragOverPh = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeavePh = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDropPh = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = e.dataTransfer.files;

    if (files.length > 0) {
      Swal.fire({
        icon: "info",
        title: "Files Selected",
        text: `${files.length} file(s) ready to upload`,
        timer: 1500,
        showConfirmButton: false,
      });

      fileInputRefPh.current.files = files;

      fileInputRefPh.current.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const [psLoading, setPsLoading] = useState(``);

  const handleFileChangePh = (e) => {
    const files = e.target.files;

    if (files.length > 0) {
      const formDataPh = new FormData();

      for (let i = 0; i < files.length; i++) {
        formDataPh.append("photos", files[i]);
      }

      // Show loader
      Swal.fire({
        title: "Uploading...",
        text: "Please wait while files are uploading",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios
        .post(Utils.apiUrl(`photoshoot/photos?psid=${id}`), formDataPh, Utils.apiHeaders())
        .then((res) => {
          Swal.close();

          if (res.data.success) {
            updatePhotoshootImages();

            Swal.fire({
              icon: "success",
              title: "Uploaded!",
              text: res.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Upload Failed",
              text: res.data.message,
            });
          }
        })
        .catch((err) => {
          console.error("Upload failed:", err);
          Swal.close();

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to upload files",
          });
        });
    }
  };

  const handleClickPh = () => {
    Swal.fire({
      icon: "info",
      title: "Select Files",
      text: "Choose images to upload",
      timer: 1200,
      showConfirmButton: false,
    });

    fileInputRefPh.current.click();
  };

  const approvedImages = (pr_status) => {
    return photoshootImages.filter((item) => item.status === "bt-approved" && (pr_status == 0 || item.pr_status === pr_status));
  };

  const handleDownload = (file) => {
    const fileType = file.filetype === 1 ? "Usage Rights" : "High Res";

    Swal.fire({
      title: `Download ${fileType}?`,
      text: "The file will be downloaded to your device",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Download",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // trigger download
        const link = document.createElement("a");
        link.href = file.filename;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        Swal.fire({
          icon: "success",
          title: "Download Started",
          text: `${fileType} is downloading...`,
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const renderMainTabs = () => {
    const status = photoshootDetails.status;
    const tabs = {
      shotlist: ["Shot-list", status >= 1],
      sdeck: ["Styling Deck", status >= 1],
      recce: ["Recce", status >= 1],
      photoshoot: ["Post Production Image Review", status >= 7],
      finaldocs: ["Download Final Images and Document", status >= 9],
    };
    return (
      <div className="flex space-x-2 border-b pb-3">
        {_.map(tabs, (tab, key) => (
          <button
            className={`tab-btn ${tab[1] && activeTab === key ? "active" : "bg-gray-100"} ${!tab[1] ? "cursor-not-allowed opacity-50" : ""}`}
            data-tab={key}
            onClick={() => (tab[1] ? setActiveTab(key) : null)}
          >
            {tab[0]}
          </button>
        ))}
      </div>
    );
  };

  const renderSubMenuForApprovedImages = () => {
    return (
      <div className="flex space-x-2" role="tablist" aria-label="Files Tabs">
        <button
          className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 2 ? "active" : "bg-gray-100"}`}
          onClick={() => setFilter({ pr_status: 2 })}
        >
          PR Requested <span className="ml-2 text-sm text-gray-600">({approvedImages(2).length})</span>
        </button>
        <button
          className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 3 ? "active" : "bg-gray-100"}`}
          onClick={() => setFilter({ pr_status: 3 })}
        >
          PR Ready <span className="ml-2 text-sm text-gray-600">({approvedImages(3).length})</span>
        </button>
        <button
          className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${filter.pr_status === 0 ? "active" : "bg-gray-100"}`}
          onClick={() => setFilter({ pr_status: 0 })}
        >
          Approved Images <span className="ml-2 text-sm text-gray-600">({approvedImages(0).length})</span>
        </button>
      </div>
    );
  };

  const showStatuses = (photoshootDetails) => {
    let showStatuses = [1, 3, 5, 7, 9, 11];
    return (
      <div className="flex flex-col items-start space-y-2">
        {_.map(showStatuses, (s, idx) => (
          <div key={idx} className={`${statusClasses[s > photoshootDetails.status ? "Pending" : "Completed"]} inline w-full text-left`}>
            <i className={`fa-solid fa-${s <= photoshootDetails.status ? "check-circle" : "circle"}`}></i> Status: {status[s]}
          </div>
        ))}
      </div>
    );
  };

  const getLatestImageVersion = (id, index) => {
    let item = photoshootImages.filter((img) => img.orig_photo_id === id);
    if (item.length > 1) {
      item = item.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
    } else {
      item = photoshootImages.find((img) => img.id === id);
    }

    return (
      <>
        <img
          src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
          alt="Pic 1"
          className="w-20 h-14 object-cover rounded mr-4"
        />
        <div className="flex-1">
          <div className="font-semibold text-gray-800">Pic {index + 1}</div>
          {/* If BT Feedback is not blank */}
          {item.bt_feedback != null && item.bt_feedback != "" && <div className="text-sm text-gray-600">{item.bt_feedback}</div>}
          {/* If BT Feedback is blank showing AI Feedback */}
          {(item.bt_feedback == null || item.bt_feedback == "") && item.ai_feedback != undefined && (
            <>
              <div className="text-sm text-gray-600">
                {item.ai_feedback != "" &&
                  (() => {
                    try {
                      const parsed = JSON.parse(item.ai_feedback);
                      return parsed.feedback.map((feedback, index) => <p key={index}>{feedback}</p>);
                    } catch (e) {
                      return <p>Invalid AI feedback</p>;
                    }
                  })()}
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <div className="container mx-auto p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Photoshoot Details</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex flex-col lg:flex-row lg:justify-between mb-6">
            <div className="text-left flex-1">
              <h2 className="text-2xl font-semibold mb-3">{photoshootDetails.title}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 mb-4">
                {/* Left Column */}
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Type</span>
                    <span className="font-medium text-gray-800">{hotel_types[photoshootDetails.hotel_type]}</span>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Photographer</span>
                    <span className="font-medium text-gray-800">{photoshootDetails.pgname}</span>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Hotel Photography Lead</span>
                    <span className="font-medium text-gray-800">{photoshootDetails.hrname}</span>
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Shoot Date</span>
                    <span className="font-medium text-gray-800">
                      {formatDate(photoshootDetails.date_from)} - {formatDate(photoshootDetails.date_to)}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Recce Completed By</span>
                    <span className="font-medium text-gray-800">{photoshootDetails.recce_end ? formatDate(photoshootDetails.recce_end) : "-"}</span>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <span className="text-sm text-gray-500">Completion Date</span>
                    <span className="font-medium text-gray-800">
                      {photoshootDetails.delivery_date ? formatDate(photoshootDetails.delivery_date) : "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-right">{showStatuses(photoshootDetails)}</div>
          </div>
          {/* <p className="text-sm text-gray-500 mt-1 text-right"><span className="font-medium text-gray-800">{photoshootDetails.status_label}</span></p> */}

          {/* <!-- Tabs --> */}
          <div className="mt-6">
            {renderMainTabs()}

            <div className="mt-6">
              {/* <!-- Tab: Photoshoot shotlist --> */}
              <div id="tab-shotlist" className={`tab-panel ${activeTab === "shotlist" ? "active" : "hidden"}`}>
                <Shotlists attachments={photoshootDetails.attachments} psId={id} canUpload={canShotList} onUpload={fetchPhotoshootDetails} />
              </div>

              {/* <!-- Tab: Styling deck --> */}
              {activeTab === "sdeck" && <RecceTab mode="sdeck" psId={id} canUpload={canSDeck} />}

              {/* <!-- Tab: Recce --> */}
              {activeTab === "recce" && <RecceTab mode="recce" psId={id} canUpload={canPSRecceUpload} />}

              {/* <!-- Tab: Photoshoot Styling Deck --> */}

              <div id="tab-photoshoot" className={`tab-panel ${activeTab === "photoshoot" ? "active" : "hidden"}`}>
                {psLoading && psLoading !== "" && <div dangerouslySetInnerHTML={{ __html: psLoading }} />}
                {canUploadPhotos() && (
                  <div
                    id="drop-zone"
                    className="drop-zone"
                    onClick={handleClickPh}
                    onDragOver={handleDragOverPh}
                    onDragLeave={handleDragLeavePh}
                    onDrop={handleDropPh}
                  >
                    Drag &amp; Drop files here or click to select
                    <input
                      name="photos"
                      type="file"
                      id="file-input"
                      multiple="multiple"
                      className="hidden"
                      ref={fileInputRefPh}
                      onChange={handleFileChangePh}
                    />
                  </div>
                )}
                <div className="mt-8">
                  {/* Sub Tabs */}
                  <div className="mb-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div>
                        {!psApproved() && (
                          <div className="flex space-x-2" role="tablist" aria-label="Files Tabs">
                            <button
                              className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "uploaded" ? "active" : "bg-gray-100"}`}
                              data-tab="uploaded"
                              onClick={() => setActivePsTab("uploaded")}
                            >
                              Uploaded{" "}
                              <span className="ml-2 text-sm text-gray-600">
                                ({photoshootImages.filter((item) => item.status === "submitted").length})
                              </span>
                            </button>
                            <button
                              className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "edits" ? "active" : "bg-gray-100"}`}
                              data-tab="edits"
                              onClick={() => setActivePsTab("edits")}
                            >
                              Edits Needed (To Review){" "}
                              <span className="ml-2 text-sm text-gray-600">
                                (
                                {
                                  photoshootImages.filter((item) =>
                                    ["ai-processed", "bt-rejected"].some((status) => item.status.includes(status) && item.orig_photo_id == null),
                                  ).length
                                }
                                )
                              </span>
                            </button>
                            <button
                              className={`files-tab-btn px-4 py-2 rounded bg-gray-100 font-semibold ${activePsTab === "approved" ? "active" : "bg-gray-100"}`}
                              data-tab="approved"
                              onClick={() => setActivePsTab("approved")}
                            >
                              Approved{" "}
                              <span className="ml-2 text-sm text-gray-600">
                                ({photoshootImages.filter((item) => item.status === "bt-approved").length})
                              </span>
                            </button>
                          </div>
                        )}
                        {psApproved() && <>{renderSubMenuForApprovedImages()}</>}
                      </div>
                      <div className="text-right text-sm">
                        <div className="block">
                          Initially Uploaded: <span>{photoshootImages.filter((item) => item.orig_photo_id == null).length}</span>
                        </div>
                        <div className="block">
                          Revision Needed:{" "}
                          <span>
                            {photoshootImages.filter((item) => ["ai-processed", "bt-rejected"].some((status) => item.status.includes(status))).length}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Uploaded Tab */}
                  {activePsTab === "uploaded" && (
                    <>
                      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Uploaded</h2>
                      <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
                        {/* <!-- Tiles will be appended here --> */}
                        {photoshootImages.length > 0 &&
                          photoshootImages
                            .filter((item) => item.status === "submitted")
                            .map((item, index) => (
                              <>
                                <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                  <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                    <img
                                      src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                      alt=""
                                      className="object-cover w-full h-full"
                                    />
                                  </div>
                                  <div className="p-3">
                                    <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                      Pic {index + 1}
                                    </div>
                                  </div>
                                  <div className="absolute top-2 right-2 flex space-x-2">
                                    <button
                                      className="w-8 h-8 flex items-center justify-center rounded-full text-red-700"
                                      aria-label="Mark approved"
                                      onClick={() => deletePhotoshootFile(item.id)}
                                    >
                                      <i className="fa-solid fa-x"></i>
                                    </button>
                                  </div>
                                </div>
                              </>
                            ))}
                      </div>
                    </>
                  )}

                  {/* Edits Needed Tab */}
                  {activePsTab === "edits" && (
                    <>
                      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Edits Needed</h2>
                      {/* <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4"> */}
                      {/* <!-- Tiles will be appended here --> */}
                      {console.log(
                        photoshootImages.filter((item) =>
                          ["ai-processed", "bt-rejected"].some((status) => item.status.includes(status) && item.orig_photo_id == null),
                        ),
                      )}
                      {photoshootImages.length > 0 &&
                        photoshootImages
                          .filter((item) =>
                            ["ai-processed", "bt-rejected"].some((status) => item.status.includes(status) && item.orig_photo_id == null),
                          )
                          .map((item, index) => (
                            <>
                              <ul className="space-y-4">
                                <li className="flex items-center bg-white rounded-lg shadow-sm border p-3">
                                  {getLatestImageVersion(item.id, index)}
                                  <div>
                                    <a
                                      href={`${process.env.REACT_APP_BASENAME}photographer-view-feedback/${id}/${item.id}`}
                                      className="inline-block items-center px-4 py-2 rounded btn"
                                    >
                                      <i className="fa-regular fa-eye"></i> View Details
                                    </a>
                                  </div>
                                </li>
                              </ul>
                            </>
                          ))}
                      {/* </div> */}
                    </>
                  )}

                  {/* Approved Tab */}
                  {activePsTab === "approved" && (
                    <>
                      <h2 className="text-2xl font-semibold text-gray-700 mb-4">Approved</h2>
                      {!psApproved() && renderSubMenuForApprovedImages()}

                      {/* <!-- Tiles will be appended here --> */}
                      {filter.pr_status == 2 && approvedImages(filter.pr_status).length > 0 && (
                        <>
                          <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2">
                            {/* <!-- Tiles will be appended here --> */}
                            {approvedImages(filter.pr_status).length > 0 &&
                              approvedImages(filter.pr_status).map((item, index) => (
                                <>
                                  <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                    <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                        alt=""
                                        className="object-cover w-full h-full"
                                      />
                                    </div>
                                    <div className="p-3">
                                      <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                        Pic {index + 1}
                                      </div>
                                    </div>
                                    {parseInt(item.pr_status) === 2 && (
                                      <div className="p-3 pt-0">
                                        <input
                                          type="checkbox"
                                          id={`pr_ready_${item.id}`}
                                          checked={prReadyIds.includes(item.id)}
                                          onChange={() => handlePrReadyChange(item.id)}
                                        />
                                        <label htmlFor={`pr_ready_${item.id}`} className="ml-2">
                                          PR Ready
                                        </label>
                                      </div>
                                    )}
                                    {/* <div className="absolute top-2 right-2 flex space-x-2">
                                              <button className="w-8 h-8 flex items-center justify-center rounded-full text-red-700" aria-label="Mark approved" onClick={() => deletePhotoshootFile(item.id)}>
                                                  <i className="fa-solid fa-x"></i>
                                              </button>
                                          </div> */}
                                  </div>
                                </>
                              ))}
                          </div>
                          {filter.pr_status === 2 && <PrRequestUpload psid={id} prReadyIds={prReadyIds} onUploadSuccess={updatePhotoshootImages} />}
                        </>
                      )}

                      {filter.pr_status == 3 &&
                        _.keys(photoshootFiles).length > 0 &&
                        _.map(photoshootFiles, (psfiles, phids) => {
                          phids = phids.includes("[") ? JSON.parse(phids) : phids.split(",").map((id) => parseInt(id.trim()));
                          return (
                            <>
                              <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 pt-2">
                                {approvedImages(filter.pr_status)
                                  .filter((item) => phids.includes(parseInt(item.id)))
                                  .map((item, index) => (
                                    <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border" key={item.id}>
                                      <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                        <img
                                          src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                          alt=""
                                          className="object-cover w-full h-full"
                                        />
                                      </div>
                                      <div className="p-3">
                                        <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                          Pic {index + 1}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>

                              {filter.pr_status == 3 &&
                                approvedImages(filter.pr_status).filter((item) => phids.includes(parseInt(item.id))).length > 0 &&
                                psfiles.map((file) => (
                                  <button
                                    onClick={() => handleDownload(file)}
                                    className="inline-flex items-center m-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                                  >
                                    <i className="fas fa-download"></i>
                                    <span className="ml-2">{file.filetype === 1 ? "Usage Rights" : "High Res"}</span>
                                  </button>
                                ))}
                            </>
                          );
                        })}

                      {filter.pr_status === 0 && (
                        <div id="file-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 mt-2">
                          {photoshootImages.length > 0 &&
                            photoshootImages
                              .filter((item) => item.status === "bt-approved")
                              .map((item, index) => (
                                <>
                                  <div className="relative bg-white rounded-lg overflow-hidden shadow-sm border">
                                    <div className="h-40 bg-gray-100 flex items-center justify-center overflow-hidden">
                                      <img
                                        src={`${process.env.REACT_APP_API_URL}/photoshoot/photo/thumb/${item.fname}`}
                                        alt=""
                                        className="object-cover w-full h-full"
                                      />
                                    </div>
                                    <div className="p-3">
                                      <div className="text-sm font-semibold text-gray-800 truncate" title="">
                                        Pic {index + 1}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
                {/* Approved Images All */}
              </div>

              {/* <!-- Tab: finaldocs (placeholder) --> */}
              <div id="tab-finaldocs" className={`tab-panel ${activeTab === "finaldocs" ? "active" : "hidden"}`}>
                <FinalDocumentTab
                  photoshootDetails={photoshootDetails}
                  finalDocs={_.filter(_.flattenDeep(_.values(photoshootFiles)), (f) => !f.isPR)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhPhotoshootDetails;
